import { Link, useHistory } from 'react-router-dom';

export const LinkLogout = () => {
  const history = useHistory();

  const to = `/logout/${history.location.search}`;

  return <Link to={to}>Logout</Link>;
};
